import { Fragment } from "react";

export interface BreadcrumbPart {
  label: string;
  mono?: boolean;
  onClick?: () => void;
}

// Breadcrumb clicável do painel de detalhe (CLP / Cartão / Sensor).
export function Breadcrumb({ parts }: { parts: BreadcrumbPart[] }) {
  return (
    <nav className="flex flex-wrap items-center gap-1.5 text-[12px] text-text-secondary">
      {parts.map((p, i) => (
        <Fragment key={`${p.label}-${i}`}>
          {i > 0 && <span className="text-text-tertiary">/</span>}
          {p.onClick ? (
            <button
              type="button"
              onClick={p.onClick}
              className={`rounded hover:text-text-primary hover:underline ${p.mono ? "font-mono" : ""}`}
            >
              {p.label}
            </button>
          ) : (
            <span className={`text-text-primary ${p.mono ? "font-mono" : ""}`}>{p.label}</span>
          )}
        </Fragment>
      ))}
    </nav>
  );
}
